export default {
  common1: 'common1',
}
